<template>
  <div>
    <div v-if="draw_categories && chartData" style="margin-bottom:10px;">
      Colored by {{chartData.meta.color_by_field}}:
      <span v-for="category in categories_for_display" style="margin-right:4px;">
                  <span
                      v-bind:style="{ borderBottom: category.color,padding:'3px', fontSize:'11px'}"
                      @mouseover.native="hover_category = category.category"
                      @mouseleave.native="hover_category=null">
                      {{category.category}}
                  </span>
              </span>
    </div>
    <div ref="d3_root"></div>
    <div v-if="draw_categories && chartData" >
            <span style="color:lightgray"><span style="color:#a1a1a1">Strip Plot</span>:
              Grouped by <span  style="color:#a1a1a1">{{chartData.meta.group_by_field}}</span>
                Positioned by <span  style="color:#a1a1a1">{{chartData.meta.x}}</span>
                labeled by <span  style="color:#a1a1a1">{{chartData.meta.label}}</span>
                <span v-if="chartData.meta.color_by_field">and colored by
                    <span  style="color:#a1a1a1">{{chartData.meta.color_by_field}}</span></span></span>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";
export default {
  name: "ChartStripPlot",
  props: ['height','width', 'text_size', 'chartData'],
  data() {
    return {
      categories: {},
      categories_for_display: [],
      draw_categories: false,
      hover_category: null,
    }
  },
  mounted() {
    if (this.chartData) {
      this.draw()
    }
  },
  watch: {
    chartData: function (newValue) {
      if (newValue) this.draw()
    },
  },
  methods: {
    draw() {

      this.categories_for_display = []
      this.categories = []
      let count = 0;
      this.chartData.data.forEach(dataPoint => {
        if (!this.categories[dataPoint.category]) {
          count++
          this.categories[dataPoint.category] = dataPoint.color
          let category_category = dataPoint.category
          if (dataPoint.category===null) {
            category_category = 'NO VALUE'
          }
          let category = {
            category: category_category,
            color: '3px solid ' + dataPoint.color
          }
          this.categories_for_display.push(category)
        }
      })
      if (count>=2) {
        this.draw_categories = true
      }

      let width = this.width
      let height = this.height
      let data = this.chartData.data

      const svg = d3.create("svg")
          .attr("viewBox", [0, 0, width, height]);

      let xAxis = g => g
          .attr("transform", `translate(0,${margin.top})`)
          .call(d3.axisTop(x).ticks(null))
          .call(g => g.selectAll(".tick line").clone().attr("stroke-opacity", 0.1).attr("y2", height - margin.bottom - margin.top))
          .call(g => g.selectAll(".domain").remove())

      let yAxis = g => g
          .attr("transform", `translate(${margin.left},0)`)
          .call(d3.axisLeft(y))
          .call(g => g.selectAll(".tick line").clone().attr("stroke-opacity", 0.1).attr("x2", width - margin.right - margin.left))
          .call(g => g.selectAll(".domain").remove())

      let margin = ({top: 20, right: 40, bottom: 10, left: 140})

      let x = d3.scaleLinear()
          .domain(d3.extent(data, d => d.value))
          .rangeRound([margin.left + 10, width - margin.right])

      let y = d3.scalePoint()
          .domain(data.map(d => d.group))
          .rangeRound([margin.top, height - margin.bottom])
          .padding(1)

      svg.append("g")
          .call(xAxis);

      svg.append("g")
          .call(yAxis);

      var jitterWidth = (((height - margin.top - margin.bottom) / count) / 2) - 5;

      svg.append("g")
          .attr("fill", "none")
          .attr("pointer-events", "all")
          .selectAll("circle")
          .data(data)
          .join("circle")
          .attr("r", 3.5)
          .attr("stroke", function(d) { return d.color;})
          .attr("stroke-opacity",0.5)
          .attr("fill", function(d) { return d.color;})
          .attr("fill-opacity",d => {
            while (d.depth > 1) d = d.parent;
            if (!this.hover_category) {
              return 0.2;
            } else if (d.category==this.hover_category) {
              return 0.3;
            }else {
              return 0.05;
            }
          })
          .attr("cx", d => x(d.value))
          .attr("cy", d => y(d.group) + Math.random()*jitterWidth-jitterWidth/2)
          .append("title")
          .text(d => `${d.label} ${(d.value).toFixed(1)} ${d.group}`);

      svg.selectAll(".dot_text")
          .data(data)
          .enter()
          .append("text")
          .attr("class", "dot_text")
          .text((d)=>{if(!d.overlaps) {return d.label} else {return ''}})
          .attr("x", (d) => x(d.value) + 5)
          .attr("y", (d) => y(d.group)) // we don't know *exactly* where the label should go vertically, so just show it on the line
          .attr("font_family", "sans-serif")  // Font type
          .attr("font-size", "11px")  // Font size
          .attr("fill", "darkgray");   // Font color

      while (this.$refs.d3_root.firstChild) {
        this.$refs.d3_root.removeChild(this.$refs.d3_root.firstChild);
      }

      this.$refs.d3_root.append(svg.node())
    }
  }
}
</script>

<style scoped>

</style>